export const TRACKING_EVENTS = {
  JOB_APPLY_FINISH: 'jobApply',
  JOB_APPLY_START: 'jobApplyStart',
  JOB_SEARCH: 'jobSearch',
  JOB_VIEW: 'jobView',
  OUTBOUND_LINK: 'outboundLink'
}
export const TRACKING_EVENTS_INFO = {
  // For all GTM events
  // `candidate_uuid` is set if logged as candidate
  // and `user_uuid`, `client_uuid` is set if logged as employer

  // JOB
  [TRACKING_EVENTS.JOB_APPLY_START]: {
    eventCategory: 'Job',
    eventAction: 'job-apply-start',
    eventLabel: null // Job apply URL or job_uuid (if modal)
    // FOR GTM:  job:{apply_url, job_uuid, job_slug, organisation_id, client_uuid}
  },
  [TRACKING_EVENTS.JOB_APPLY_FINISH]: {
    eventCategory: 'Job',
    eventAction: 'apply',
    eventLabel: null, // job_uuid
    // FOR GTM:  job:{job_uuid, job_slug, organisation_id, client_uuid}
  },
  [TRACKING_EVENTS.JOB_SEARCH]: {
    eventCategory: 'Job',
    eventAction: 'load-jobs',
    eventLabel: null, // Query Params stringify-ed,
    eventValue: null // Number of jobs after search
  },
  [TRACKING_EVENTS.JOB_VIEW]: {
    eventCategory: 'Job',
    eventAction: 'job-view',
    eventLabel: null, // job_uuid
    // FOR GTM:  job:{job_uuid, job_slug, organisation_id, client_uuid}
  },
  //general
  [TRACKING_EVENTS.OUTBOUND_LINK]: {
    eventCategory: 'Outbound',
    eventAction: 'click',
    eventLabel: null // Link URL
    // FOR GTM when clicked from job details:  job:{job_uuid, job_slug, organisation_id, client_uuid}
  },
}
